import React from "react";
import MultipleLoadingScreen from "../../design-system/MultipleLoadingScreen";
import { giveErrorMessage, SeedType } from "../../utils/common";
import { SeedItem } from "../../components/SeedItem/SeedItem";

interface CitationExplorerProps {
    seeds: SeedType[];
    searchLoading: boolean;
    error: string | null;
    hasSearched: boolean;
    onCitationClick?: (citation: any) => void;

}

const CitationExplorer: React.FC<CitationExplorerProps> = ({
    seeds,
    searchLoading,
    error,
    hasSearched,
    onCitationClick
}) => {

    function onCitationClicked(seed: any): void {
        if (onCitationClick) {
          onCitationClick(seed);
        }
      }
    if (error) {
        return (
            <div className="flex justify-center text-red-600 p-4">
                {error}
            </div>
        );
    }

    if (searchLoading) {
        return <MultipleLoadingScreen count={3} />;
    }

    if ( !searchLoading && seeds.length === 0 && hasSearched) {
        return (
            <div className="flex justify-center text-slate-500 p-4">
                No results found.
            </div>
        );
    }

    return (
        <div>
            {seeds.map((seed, index) => (
                <SeedItem key={index} seed={seed} onCitationClick={onCitationClicked}/>
            ))}
        </div>
    );
};

export default CitationExplorer;
